import Service from "./Service";
const baseurl = '/api/valoracion-historia';

export default {
    store(data){
        return Service.post(`${baseurl}/store`,data);
    },
    show(id){
        return Service.get(`${baseurl}/show-by-idHistoria/${id}`);
    }
}